const DETAIL_GRAPH_MID_WIDTH_PX = 300;

export { DETAIL_GRAPH_MID_WIDTH_PX };
